import { render } from "./MonitorOrder.vue?vue&type=template&id=11ff6d6f"
import script from "./MonitorOrder.vue?vue&type=script&lang=js"
export * from "./MonitorOrder.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__